import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";
import { Division } from "../types/Division";
import { env } from "../utils/env";

const fetchDivisions = (authHeader: string) => () =>
  axios.get<Division[]>(`${env.verifyServiceUrl}common/division/`, {
    headers: {
      Authorization: authHeader,
    },
    params: { all: true },
  });

export const useDivisions = () => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  return useQuery(["divisions"], fetchDivisions(authHeader), {
    retry: false,
    onError: (err: any) => {
      if (err.request?.status === 500 || err.request?.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
      if (err.request?.status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    },
  });
};
